import { identity } from '@kofno/piper';
import clsx from 'clsx';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import Select from 'react-select';
import { Link } from '../../../../../Resource/Types';
import { TPlainTextKey } from '../../../../../Translations';
import Label from '../../../../Form/Label';
import { StringOption } from '../../../../Options/Types';
import { stylesConfig } from './Styles';
import { useOrganizationFilterTypeahead } from './UseOrganizationFilterTypeahead';
import { State } from './UseOrganizationFilterTypeahead/Types';

export interface Props {
  name: string;
  endpoint: Link;
  label: TPlainTextKey;
  labelClassname: string;
  initialValue: Maybe<StringOption>;
  onChange: (value: StringOption) => void;
  className?: string;
}

export const selectedValue = (state: State): StringOption | undefined => {
  switch (state.kind) {
    case 'loading':
    case 'ready':
    case 'filtering':
      return undefined;
    case 'filtered':
      return state.selectedValue.map<StringOption | undefined>(identity).getOrElseValue(undefined);
    case 'option-selected':
      return state.selectedValue;
    case 'error':
      return undefined;
  }
};

function OrganizationFilterTypeahead({
  name,
  endpoint,
  label,
  labelClassname,
  initialValue,
  onChange,
  className,
}: Props) {
  const { state, handleInputChange, handleSelectionChange, isLoading, options, placeholder } =
    useOrganizationFilterTypeahead(endpoint, onChange, initialValue);
  return (
    <>
      <div className={clsx('min-w-[200px]', className)} data-intercom-target="organization-filter">
        <Label htmlFor={name} labelText={label} className={labelClassname} />
        <Select
          name={name}
          inputId={name}
          value={selectedValue(state)}
          styles={stylesConfig}
          onChange={handleSelectionChange}
          options={options}
          isLoading={isLoading}
          placeholder={placeholder}
          isSearchable
          isClearable
          onInputChange={handleInputChange}
          components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
          menuPortalTarget={document.body}
        />
      </div>
    </>
  );
}

export default observer(OrganizationFilterTypeahead);
